import { render, staticRenderFns } from "./SharedLinkDeleteSelectedDialogBox.vue?vue&type=template&id=2c0c7e74&scoped=true&"
import script from "./SharedLinkDeleteSelectedDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkDeleteSelectedDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c7e74",
  null
  
)

export default component.exports